import React, { useState } from 'react';
export interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}
export interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
}
export function Tabs({
  tabs,
  defaultTab
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);
  const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;
  return <div className="w-full" data-id="element-384">
      <div className="border-b border-slate-200" data-id="element-385">
        <nav className="flex space-x-8" data-id="element-386">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id ? 'border-[var(--nmhl-burgundy)]' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`} style={activeTab === tab.id ? {
          color: 'var(--nmhl-burgundy)'
        } : {}} data-id="element-387">
              {tab.label}
            </button>)}
        </nav>
      </div>
      <div className="mt-6" data-id="element-388">{activeTabContent}</div>
    </div>;
}